module.exports = __webpack_public_path__ + "static/media/linkedin.59ae856a.png";